import React from "react";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import JarvisDialog from "components/JarvisDialog";
import RiskProfileGraph from "components/Profile/RiskProfileGraph";

const RISK_PROFILE_COLORS = {
  1: "#1c8d13",
  2: "#83c605",
  3: "#00C565",
  4: "#ecb004",
  5: "#df873a",
  6: "#d44c4c",
};

/**
 * Figma 7991:127290 — "Risk Profile" section: header row (title + change
 * link) followed by a card showing the risk profile name + gauge.
 */
const RiskProfilePanel = ({ riskProfile, riskProfileId, onChangeClick }) => {
  const color = RISK_PROFILE_COLORS[riskProfileId] || "#111827";

  return (
    <Stack spacing={3} sx={{ width: "100%" }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Text sx={{ fontWeight: 700, fontSize: "20px", color: "#111827" }}>
          Risk Profile
        </Text>
        <JarvisDialog
          openComponent={(onOpen) => (
            <Text
              onClick={onOpen}
              sx={{
                fontWeight: 600,
                fontSize: "14px",
                color: "#3B82F6",
                textDecoration: "underline",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              Change my Risk Profile
            </Text>
          )}
          title={"Change Risk Profile?"}
          content={
            <>
              <span style={{ fontWeight: 500 }}>
                Rebalancing Portfolio is needed
              </span>{" "}
              when you change your
              <br />
              current risk profile to another one.
            </>
          }
          note={
            <>
              Note : You can only change risk profile
              <br /> once in 6 months
            </>
          }
          onConfirm={(onClose) => onChangeClick(onClose)}
        />
      </Stack>

      <Box
        sx={{
          bgcolor: "#fff",
          border: "1px solid #E2E8F0",
          borderRadius: "20px",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.02)",
          p: { xs: 3, md: 4 },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
        >
          <Stack spacing={0.5}>
            <Text
              sx={{ fontWeight: 700, fontSize: "20px", color, lineHeight: 1 }}
            >
              {riskProfile || "—"}
            </Text>
            <Text sx={{ fontWeight: 400, fontSize: "14px", color: "#4B5563" }}>
              Your Risk Profile
            </Text>
          </Stack>
          <Box sx={{ flexShrink: 0 }}>
            <RiskProfileGraph
              riskProfileId={riskProfileId}
              chartWidth={180}
              needleLenght={40}
              disableLabel
            />
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
};

export default RiskProfilePanel;
